// quote.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { Quote, QuoteListResponse } from '../../models/quote-response.interface';
import {
  QuotationDetail,
  QuoteResponse,
  QuoteVerificationResponse,
} from '../../models/quote-response.model';
import { UrlReferenceService } from './url-reference.service';
import { ApiResponse } from '../../models/api-response.interface';
import { environment } from '../../../assets/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class QuoteService {
  constructor(private http: HttpClient, private urlRef: UrlReferenceService) {}
  private cachedQuotesMap = new Map<string, any[]>();

  public getCachedQuotes(companyId: string): any[] | undefined {
    return this.cachedQuotesMap.get(companyId);
  }

  public setCachedQuotes(companyId: string, quotes: any[]): void {
    console.log(`Setting cached quotes for companyId ${companyId}:`, quotes);
    this.cachedQuotesMap.set(companyId, quotes);
  }

  getActiveQuotes(companyId: number, searchTerm: string = '', page: number = 0, size: number = 20): Observable<QuoteListResponse> {
    let params = new HttpParams()
      .set('companyId', companyId)
      .set('searchTerm', searchTerm)
      .set('status', 'COMPLETED')
      .set('isActive', 'true')
      .set('page', page.toString())
      .set('size', size.toString());

    return this.http.get<QuoteListResponse>(
      `${this.urlRef.quotationsUrl}/list`,
      { params }
    );
  }

  getQuoteById(id: string): Observable<Quote> {
    return this.http.get<Quote>(`${this.urlRef.currentBaseUrl}/quotes/${id}`);
  }

  getQuotes(
    companyId: string,
    timeRange: string,
    sortBy?: string,
    sortDirection?: string
  ): Observable<QuoteResponse[]> {
    let params = new HttpParams()
      .set('timeRange', timeRange);

    if (sortBy) {
      params = params.set('sortBy', sortBy);
    }

    if (sortDirection) {
      params = params.set('sortDirection', sortDirection);
    }

    return this.http.get<QuoteResponse[]>(
      `${environment.backend.senderService?.baseApiUrl}/payers/list-quotas/${companyId}`,
      { params }
    );
  }

  sendQuote(crNumber: string): Observable<QuoteResponse> {
    return this.http.post<any>(
      `${environment.backend.senderService?.baseApiUrl}/payers/send-quotas/` +
        crNumber,
      {
        headers: { 'Content-Type': 'application/json' },
      }
    );
  }

  verifyQuote(body: any): Observable<QuoteVerificationResponse> {
    return this.http.post<any>(
      `${environment.backend.senderService?.baseApiUrl}/payers/send-verify`,
      body,
      {
        headers: { 'Content-Type': 'application/json' },
      }
    );
  }

  getQuotationDetail(quoteResponseId: string): Observable<QuotationDetail> {
    return this.http.get<QuotationDetail>(
      `${environment.backend.searchService?.baseApiUrl}/quotations/${quoteResponseId}`
    );
  }
}
